import styled from "styled-components";

export const AddOnDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: auto;
`;
